import React from 'react';

export default function Stars({ value = 0, size = 16, className = '', onChange, interactive = false }) {
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className={`inline-flex items-center ${className}`} role={interactive ? 'radiogroup' : undefined} aria-label="Rating">
      {stars.map((s) => {
        const filled = value >= s;
        const Star = (
          <svg
            key={s}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill={filled ? 'currentColor' : 'none'}
            stroke="currentColor"
            className={`mx-0.5 ${filled ? 'text-black dark:text-white' : 'text-gray-300 dark:text-gray-600'}`}
            aria-checked={interactive ? (value === s) : undefined}
            role={interactive ? 'radio' : undefined}
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.563.563 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.482 20.54a.563.563 0 01-.84-.61l1.285-5.386a.563.563 0 00-.182-.557L2.54 10.385a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L10.98 3.5z" />
          </svg>
        );
        if (!interactive) return Star;
        return (
          <button
            key={s}
            type="button"
            onClick={() => onChange?.(s)}
            className="focus:outline-none focus:ring-0 focus:ring-yellow-500 rounded"
            aria-label={`${s} star${s>1?'s':''}`}
          >
            {Star}
          </button>
        );
      })}
    </div>
  );
}


